import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  standalone: false,
  selector: 'input[matInput]' // applies to every <input matInput>
})
export class InputMaxLenghtDirective implements OnInit {
   private maxLenghtValue: string = '250';

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'maxlength', this.maxLenghtValue);
    console.log('MaxLengthDirective applied');
  }
}
